module.exports = __webpack_public_path__ + "static/media/change_03.a985c10e.jpg";